import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ProductVariantDetailsFragment = { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, wholesaleDescription: string, isCustomizable: boolean, properties: Array<{ id: number, pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } } };

export const ProductVariantDetailsFragmentDoc = gql`
    fragment ProductVariantDetailsFragment on ProductVariantType {
  id
  pk
  name
  sku
  weightOverride
  unitCoeff
  wholesaleDescription
  isCustomizable
  properties {
    id
    pk
    attributeName
    valueName
  }
  priceRange {
    currency
    discount {
      min
      max
    }
  }
}
    `;